import { Microfrontend } from '@cian/mf-react';
import * as React from 'react';

import { PageWrapper } from '../../components/PageWrapper';
import { useApplicationContext } from '../ApplicationContext';
import { FeedbackFormWrapper } from '../../components/FeedbackFormWrapper';

export const PageContainer: React.FC = () => {
  const context = useApplicationContext();
  const { microfrontendName, imageVersion, runtimeName, instanceId, parameters } = context.custom.feedbackFormManifest;

  return (
    <PageWrapper>
      <FeedbackFormWrapper>
        <Microfrontend
          name={microfrontendName}
          image={imageVersion}
          runtime={runtimeName}
          instance={instanceId}
          parameters={parameters}
        />
      </FeedbackFormWrapper>
    </PageWrapper>
  );
};
